import { render, staticRenderFns } from "./pbi-report.vue?vue&type=template&id=9853d9a0"
import script from "./pbi-report.vue?vue&type=script&lang=js"
export * from "./pbi-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports